import omit from "lodash/omit";
import { ActivityCustomField, ActivityPureCustomValue } from "PFTypes";

export const sanitizeCustomFieldsForAPI = (customFields: ActivityCustomField[]): ActivityCustomField[] =>
  customFields.map((customField) => ({
    ...customField,
    values: customField.values.map((value) =>
      value.created ? (omit(value, ["id", "created"]) as ActivityPureCustomValue) : value
    )
  }));
